import React from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login/Login';
import Header from './components/layout/header/Header';
import SidebarLeft from './components/layout/sidebarLeft/SidebarLeft';
import Dashboard from './pages/dashboard/Dashboard';
import Company from './pages/management/company/Company';
import CompanyForm from './pages/management/company/CompanyForm';
import Category from './pages/management/category/Category';
import ThemeTest from './components/theme/ThemeTest';
import PrivateRoute from './components/privateRoute/PrivateRoute';
import Product from './pages/management/product/Product';
import Stay from './pages/operation/stay/Stay';
import CareLink from './pages/operation/carelink/CareLink';
import CareLinkManage from './pages/operation/carelink/CareLinkManage';
import ThemeProvider from './components/theme/ThemeProvider';
import DynamicFavicon from './components/common/DynamicFavicon';
import Profile from './pages/profile/Profile';
import People from './pages/management/people/People';
import PeopleForm from './pages/management/people/PeopleForm';
import Role from './pages/management/role/Role';
import BpmModeler from './pages/BPM/modeler/BpmModeler';
import BpmModelerEditor from './pages/BPM/modeler/BpmModelerEditor';
import BpmForm from './pages/BPM/form/BpmForm';
import BpmFormEditor from './pages/BPM/form/BpmFormEditor';
import Alerts from './pages/alerts/Alerts';
import { TabProvider } from './contexts/TabContext';
import { NotificationProvider } from './contexts/NotificationContext';
import TabManager from './components/common/TabManager';

// Importación del prototipo
import LandingCareLink from './components/prototypes/LandingCareLink';

function App() {
  return (
    <>
      <DynamicFavicon />
      <Router>
        <NotificationProvider>
          <TabProvider>
            <Routes>
              {/* Public CareLink routes */}
              <Route path="/carelink" element={<LandingCareLink />} />
              <Route path="/carelink/:publicToken" element={<CareLink />} />

              <Route path="/" element={<Login />} />
              <Route path="/dashboard" element={<PrivateRoute element={<MainLayout><Dashboard /></MainLayout>} />} />
              <Route path="/company" element={<PrivateRoute element={<MainLayout><Company /></MainLayout>} />} />
              <Route path="/company-add" element={<PrivateRoute element={<MainLayout><CompanyForm /></MainLayout>} />} />
              <Route path="/company-edit" element={<PrivateRoute element={<MainLayout><CompanyForm /></MainLayout>} />} />
              <Route path="/theme-test" element={<PrivateRoute element={<MainLayout><ThemeTest /></MainLayout>} />} />
              <Route path="/category" element={<PrivateRoute element={<MainLayout><Category /></MainLayout>} />} />
              <Route path="/product" element={<PrivateRoute element={<MainLayout><Product /></MainLayout>} />} />
              <Route path="/stay" element={<PrivateRoute element={<MainLayout><Stay /></MainLayout>} />} />
              <Route path="/carelink-manage" element={<PrivateRoute element={<MainLayout><CareLinkManage /></MainLayout>} />} />
              <Route path="/people" element={<PrivateRoute element={<MainLayout><People /></MainLayout>} />} />
              <Route path="/people-add" element={<PrivateRoute element={<MainLayout><PeopleForm /></MainLayout>} />} />
              <Route path="/people-edit" element={<PrivateRoute element={<MainLayout><PeopleForm /></MainLayout>} />} />
              <Route path="/role" element={<PrivateRoute element={<MainLayout><Role /></MainLayout>} />} />
              <Route path="/profile" element={<PrivateRoute element={<MainLayout><Profile /></MainLayout>} />} />
              <Route path="/bpm/modeler" element={<PrivateRoute element={<MainLayout><BpmModeler /></MainLayout>} />} />
              <Route path="/bpm/modeler/add" element={<PrivateRoute element={<MainLayout><BpmModelerEditor /></MainLayout>} />} />
              <Route path="/bpm/modeler/edit" element={<PrivateRoute element={<MainLayout><BpmModelerEditor /></MainLayout>} />} />
              <Route path="/bpm/form" element={<PrivateRoute element={<MainLayout><BpmForm /></MainLayout>} />} />
              <Route path="/bpm/form/add" element={<PrivateRoute element={<MainLayout><BpmFormEditor /></MainLayout>} />} />
              <Route path="/bpm/form/edit" element={<PrivateRoute element={<MainLayout><BpmFormEditor /></MainLayout>} />} />
              <Route path="/alerts" element={<PrivateRoute element={<MainLayout><Alerts /></MainLayout>} />} />
            </Routes>
          </TabProvider>
        </NotificationProvider>
      </Router>
    </>
  );
}

const MainLayout = ({ children }) => (
  <ThemeProvider>
    <section className="body">
      <Header />
      <div className="inner-wrapper">
        <SidebarLeft />
        <section role="main" className="content-body">
          <TabManager />
          <div className="tab-content">
            {children}
          </div>
        </section>
      </div>
    </section>
  </ThemeProvider>
);

export default App;
